export const getQuestions = (state) => state.usersByAnswers.questions;

export const getCountryLanguageCode = (state) => state.usersByAnswers.countryLanguageCode;
